<template>
  <div class="imagem">
    <SliderSwiper 
      :images="images" />
    <MenuSasUma />
  </div>
</template>

<script>
import { ref } from 'vue';
import SliderSwiper from "@/components/SliderSwiper.vue";
import MenuSasUma from '@/components/MenuSasUma.vue';

export default {
  components: {
    SliderSwiper,
    MenuSasUma
  },
  setup() {

    const images = ref(["sasuma.jpg","alimentacao1.jpg","alojamento1.jpg"]);
    const menuOpen = ref(false)
    return {
      images,
      menuOpen
    }
  }
}
</script>

<style lang="scss" scoped>
/*#region banner*/
.imagem {
    position: relative;
}

.imagem img{
  width: 100%;
}

.img_faculdade_mobile {
    display: none;
}

.camada2{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: repeating-linear-gradient(-40deg, #12171d, #12051D 1px, #12051D 1px, #12171d 4px);
  opacity: 0.5;
  z-index: 0;
}

.camada2.nogradient{
  background: linear-gradient(-40deg, #12171d, #12051D 1px, #12051D 1px, #12171d 4px);
}

.imagem .titulo {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: 30%;
  text-align: center;
  z-index: 3;
}

.imagem .titulo h1 {
  font-family: "Montserrat Bold";
  color: white;
  font-size: 60px;
  margin-bottom: 0px;
  z-index: 3;
  white-space: nowrap;
  display: inline-block;
  opacity: 0;
}
/*#endregion*/

/*#region textos*/
.wrap2 {
  padding-left: 0px;
  padding-right: 0px;
  max-width: 100%;
  margin: 0;
  /*background-color: #f3f3f5;*/
}

.texto1 {
  font-family: "PT Sans Italic";
  font-size: 25px;
  line-height: 1.99;
  padding-top: 90px;
  padding-bottom: 25px;
  color: #333333;
  padding-right: 10px;
  padding-left: 3%;
}

.texto2 {
  font-family: 'PT Sans';
  color: #333333;
  line-height: 2.5;
  font-size: 17px;
  margin-bottom: 90px;
  margin-top: 90px;
}

/*#endregion*/
/*#endregion*/



.sasuma_video {
  margin-bottom: 50px;

}

.menu_sasuma .columns a {
  text-align: center;
  display: block;
  font-family: "Montserrat Bold";
  text-transform: uppercase;
  color: white;
  padding-top: 30px;
  padding-bottom: 30px;
}

.menu_sasuma {
  position: absolute;
  left: 0;
  right: 0;
  bottom:0;
  z-index: 55;
}

.mobile_menu{
  display: none;
}

@media (max-width: 767px) {

    .mobile_menu{
      display: block;
      position: absolute;
      top: 85%;
      right: 0;
      left: 0;
      padding: 10px 10px 10px;
      background-color: rgba(19,128,160,0.52);
      transition: height 1s ease;
      max-height: 44px;
      z-index: 55;
    }

    .mobile_menu.isOpen{
      background-color: rgb(19,128,160);
      max-height: 500px;
    }

    .mobile_menu .options a{
      margin-left: 20px;
      font-size: 16px;
      color: white;
      font-family: "Montserrat SemiBold";
      display: block;
      margin-top: 20px;
    }

    .mobile_menu .options a:first-of-type{
      margin-top: 0;
    }

    .mobile_menu .options .b-menu{
      right: 10%;
    }

}

.menu_sasuma .columns:nth-child(2n-1) {
  background-color: #1380a085;
}

.menu_sasuma .columns:nth-child(2n) {
  background-color: #1380a085;
}


@media (max-width: 1025px) {
  .menu_sasuma .columns{
    flex: 0 0 16.666666%;
    font-size: 12px;
  }
}

@media (max-width: 767px) {
  .menu_sasuma{
      display: none;
  }
}


.menu_sasuma .columns:hover {
  background-color: #1380a0e0;;
}

@media (max-width: 1300px) {
  .imagem .titulo h1 {
    font-size: 50px;
  }
}




@media (max-width: 1024px) {
    .imagem .titulo h1 {
        font-size: 40px;
    }
}

@media (max-width: 1023px) {

    .imagem .titulo h1 {
        font-size: 40px;
    }

    .texto2 {
        margin-top: 0px;
    }

    .texto1 {
        padding-left: 0px;
        padding-top: 60px;
    }


    .servicosList .servicoitem:nth-of-type(3){
        padding-right: 0px;
        padding-left: 15px;
    }
}





@media (max-width: 767px) {

    .img_faculdade_mobile {
        display: block;
        height: 300px;
        background-size: cover;
        background-position: center;
    }

    .imagem img {
        display: none;
    }

    .imagem .titulo h1 {
        font-size: 20px;
        margin-top: 40px;
    }

    .texto1 {
        font-size: 20px;
        line-height: 1.69;
        padding-top: 50px;
        padding-right: 0px;
        padding-left: 0px;
    }

    .texto2 {
        font-size: 14px;
        line-height: 2;
        font-family: 'PT Sans';
        color: #333333;
        margin-top: 0px;
        margin-bottom: 45px;
    }

}


@media (max-width: 639px) {
    .servicosList .servicoitem:nth-of-type(3){
        padding-right: 10px;
        padding-left: 10px;
    }
}
</style>